import { combineReducers } from 'redux';
import { LOCATION_CHANGE } from 'react-router-redux';
import pathToRegexp from 'path-to-regexp';
import * as ActionTypes from './people.actionTypes';
import merge from 'lodash/merge';

const allIds = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.READ_PERSON_SUCCESS: {
      const newEntryIndex = state.indexOf(action.response.result);
      if (newEntryIndex > -1) {
        return state;
      }
      return [...state, action.response.result];
    }
    case ActionTypes.READ_PEOPLE_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

const browser = (
  state = { ids: [], current: null },
  action
) => {
  switch (action.type) {
    case LOCATION_CHANGE: {
      const re = pathToRegexp('/team/:person');
      const result = re.exec(action.payload.pathname);
      const current = (result && result[1]) || null;
      return {
        ...state,
        current,
      };
    }
    case ActionTypes.POPULATE_PEOPLE_MODAL: {
      return {
        ...state,
        ids: action.payload.ids,
      };
    }
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.people
  ) {
    return merge({}, state, action.response.entities.people);
  }
  return state;
};

const reducer = combineReducers({
  allIds,
  byId,
  browser,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/people/people.reducer.js